module.exports = __webpack_public_path__ + "static/media/user.7e2c4bfb.svg";